// @flow
import React, { type Element } from 'react';
import ContentAdminEdit from './ContentAdminEdit';

const ContentAdminList = (): Element<*> => <ContentAdminEdit />;

export default ContentAdminList;
